var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1248 4.55261L8.29362 6.76098C8.03294 6.95666 7.71215 7.0629 7.38193 7.0629C7.05172 7.0629 6.73092 6.95666 6.47024 6.76098L3.61914 4.55902",
    stroke: "#777E8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.24232 1H10.4882C10.9352 1.00704 11.3761 1.10127 11.7844 1.27704C12.1927 1.45281 12.5599 1.7065 12.864 2.02282C13.1682 2.33914 13.4029 2.71154 13.5541 3.11769C13.7052 3.52383 13.7698 3.95529 13.7438 4.38613V8.56603C13.7698 8.99634 13.7054 9.42727 13.5546 9.83299C13.4039 10.2387 13.1698 10.6109 12.8663 10.9271C12.5629 11.2433 12.1965 11.4971 11.7889 11.6733C11.3814 11.8494 10.9413 11.9443 10.4949 11.9522H4.24232C2.30622 11.9522 1 10.4351 1 8.57244V4.39254C1 2.51704 2.30622 1 4.24232 1Z",
    stroke: "#777E8F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mailIcon.a87d23fb341416dcaeb81a6e9b549042.svg";
export { ForwardRef as ReactComponent };